import React from 'react';
import { BuildingIcon, StarIcon, MessageSquareIcon, MapPinIcon, PhoneIcon, GlobeIcon, MailIcon, TagsIcon, ClockIcon } from 'lucide-react';
export function DataFieldsSection() {
  return <section className="py-24 bg-slate-50" data-id="element-1893">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1894">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1895">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1896">
            Every data field from{' '}
            <span className="text-blue-600" data-id="element-1897">Google Maps</span>, enriched and
            verified
          </h2>
          <p className="text-xl text-slate-600" data-id="element-1898">
            Our Google Maps scraper extracts 50+ fields per business. From basic
            info to owner contacts — all enriched and ready to export.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1899">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1900">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1901">
              <BuildingIcon className="w-6 h-6" data-id="element-1902" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1903">
              Business name
            </h3>
            <p className="text-slate-600" data-id="element-1904">
              Exact registered name on Google Maps
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1905">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1906">
              <StarIcon className="w-6 h-6" data-id="element-1907" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1908">Rating</h3>
            <p className="text-slate-600" data-id="element-1909">Average star rating from customers</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1910">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1911">
              <MessageSquareIcon className="w-6 h-6" data-id="element-1912" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1913">
              Reviews count
            </h3>
            <p className="text-slate-600" data-id="element-1914">Total number of reviews received</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1915">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1916">
              <MapPinIcon className="w-6 h-6" data-id="element-1917" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1918">
              Full address
            </h3>
            <p className="text-slate-600" data-id="element-1919">Street, city, state, and zip code</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1920">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1921">
              <PhoneIcon className="w-6 h-6" data-id="element-1922" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1923">
              Phone number
            </h3>
            <p className="text-slate-600" data-id="element-1924">Direct business line for calling</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1925">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1926">
              <GlobeIcon className="w-6 h-6" data-id="element-1927" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1928">
              Website URL
            </h3>
            <p className="text-slate-600" data-id="element-1929">
              Link to the official business website
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1930">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1931">
              <MailIcon className="w-6 h-6" data-id="element-1932" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1933">
              Email address
            </h3>
            <p className="text-slate-600" data-id="element-1934">
              Verified contact emails when available
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1935">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1936">
              <TagsIcon className="w-6 h-6" data-id="element-1937" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1938">
              Categories
            </h3>
            <p className="text-slate-600" data-id="element-1939">
              Primary and secondary business types
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1940">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1941">
              <ClockIcon className="w-6 h-6" data-id="element-1942" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1943">
              Operating hours
            </h3>
            <p className="text-slate-600" data-id="element-1944">Daily open and close times</p>
          </div>
        </div>
      </div>
    </section>;
}